import { useCallback } from "react";
import { useLenis } from "lenis/react";

export function useScrollTo() {
  const lenis = useLenis();
  return useCallback(
    (href) => {
      if (lenis) lenis.scrollTo(href, { offset: -72, duration: 1.4 });
      else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    },
    [lenis]
  );
}
